import React, { useState } from "react"
import PropTypes from "prop-types"
import { TextField } from "@mui/material"

const DescriptionEditCell = params => {
  const { id, value, api, onTabKeyDown } = params

  return (
    <TextField
      size="small"
      defaultValue={value ?? ""}
      autoFocus
      onFocus={e => e.target.select()}
      onChange={e => {
        api.setEditCellValue(
          { id, field: "description", value: e.target.value },
          e,
        )
      }}
      onKeyDown={e => onTabKeyDown?.(e, "description", params)}
      fullWidth
    />
  )
}

const QuantityEditCell = params => {
  const { id, value, api, row, onTabKeyDown } = params
  const isPercent = row.unity === "%"
  const raw = parseFloat(value ?? 0) || 0
  const initial = isPercent ? raw * 100 : raw
  const [local, setLocal] = useState(String(initial))

  const handleChange = e => {
    const input = e.target.value
    setLocal(input)

    const num = Number(input)
    if (!Number.isNaN(num)) {
      api.setEditCellValue({ id, field: "quantity", value: num }, e)
    }
  }

  return (
    <TextField
      type="number"
      size="small"
      value={local}
      autoFocus
      onFocus={e => e.target.select()}
      onChange={handleChange}
      onKeyDown={e => onTabKeyDown?.(e, "quantity", params)}
      inputProps={{
        step: "0.01",
        min: isPercent ? 0 : undefined,
        max: isPercent ? 100 : undefined,
      }}
      fullWidth
    />
  )
}

const WasteEditCell = params => {
  const { id, value, api, onTabKeyDown } = params
  const [local, setLocal] = useState(String(value ?? 0))

  const handleChange = e => {
    const input = e.target.value
    setLocal(input)

    const num = Number(input)
    if (!Number.isNaN(num)) {
      api.setEditCellValue({ id, field: "waste", value: num }, e)
    }
  }

  const handleBlur = () => {
    api.stopCellEditMode({ id, field: "waste" })
  }

  return (
    <TextField
      type="number"
      size="small"
      value={local}
      autoFocus
      onFocus={e => e.target.select()}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={e => onTabKeyDown?.(e, "waste", params)}
      inputProps={{ step: "0.01" }}
      fullWidth
    />
  )
}

const PriceReducedEditCell = params => {
  const { id, value, api } = params

  return (
    <TextField
      type="number"
      size="small"
      value={value ?? ""}
      onChange={e => {
        const nextValue = e.target.value
        api.setEditCellValue(
          {
            id,
            field: "priceReduced",
            value: nextValue === "" ? null : Number(nextValue),
          },
          e,
        )
      }}
      inputProps={{ step: "0.01" }}
      fullWidth
    />
  )
}

DescriptionEditCell.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.any,
  api: PropTypes.shape({
    setEditCellValue: PropTypes.func.isRequired,
  }).isRequired,
  onTabKeyDown: PropTypes.func,
}

QuantityEditCell.propTypes = DescriptionEditCell.propTypes
WasteEditCell.propTypes = DescriptionEditCell.propTypes
PriceReducedEditCell.propTypes = DescriptionEditCell.propTypes

export {
  DescriptionEditCell,
  QuantityEditCell,
  WasteEditCell,
  PriceReducedEditCell,
}
